/** Shared Google Cloud + Search Console setup guide (onboarding + settings help). */

export const SETUP_VIDEO_URL =
  'https://static.mizfa.tools/img/preview/indexer/setup-indexer.mp4';

export type GoogleSetupInlineLink = {
  href: string;
  label: string;
};

/** Plain text, or text with an inline link (`before` + link + `after`). */
export type GoogleSetupItem =
  | string
  | {
      before?: string;
      link: GoogleSetupInlineLink;
      after?: string;
    };

export type GoogleSetupSection = {
  title: string;
  items: GoogleSetupItem[];
  link?: string;
  linkLabel?: string;
  links?: GoogleSetupInlineLink[];
};

export const CLOUD_PROJECT_CREATE_URL =
  'https://console.cloud.google.com/projectcreate';

export const SETUP_SECTIONS: GoogleSetupSection[] = [
  {
    title: 'ساخت پروژه در گوگل کلاد',
    items: [
      {
        before: 'روی ',
        link: {
          href: CLOUD_PROJECT_CREATE_URL,
          label: 'ایجاد پروژه در Google Cloud Console',
        },
        after: ' کلیک کنید. (با وی پی ان وارد بشید)',
      },
      'سپس در بخش Project name اسم Indexer Mizfa Tools درج کنید. (می‌تونید نام سایت خودتون درج کنید)',
    ],
  },
  {
    title: 'فعال‌سازی APIها',
    items: [
      'وارد دو لینک زیر بشید و مطمئن باشید Project که در مرحله قبل ساختید انتخاب شده باشه و سپس Enable بزنید:',
      {
        link: {
          href: 'https://console.cloud.google.com/apis/library/indexing.googleapis.com',
          label: 'Web Search Indexing API',
        },
      },
      {
        link: {
          href: 'https://console.cloud.google.com/apis/library/searchconsole.googleapis.com',
          label: 'Google Search Console API',
        },
      },
    ],
  },
  {
    title: 'ساخت Service Account',
    items: [
      {
        before: 'دوباره وارد ',
        link: {
          href: 'https://console.cloud.google.com/iam-admin/serviceaccounts',
          label: 'Google Cloud Console',
        },
        after:
          ' بشید و Project name که ساختید رو انتخاب کنید (الان شما باید در بخش IAM & Admin > Service Accounts باشید).',
      },
      'بخش بالا روی دکمه CREATE SERVICE ACCOUNT کلیک کنید.',
      'اسم انتخاب کنید و سپس Create and Continue بزنید.',
      'بخش Select a role گزینه Owner در سمت راست رو انتخاب کنید و دکمه‌های Continue و Done به ترتیب بزنید.',
    ],
  },
  {
    title: 'دانلود JSON و آپلود در ابزار',
    items: [
      'روی ایمیلی که گوگل ساخته کلیک کنید.',
      'بخش بالا روی Keys کلیک کنید. سپس Add Key -> Create new key از نوع JSON بزنید تا دانلود کنید.',
      'فایل دانلود شده رو در میزفا تولز در همین صفحه اپلود کنید.',
      'سپس مرحله مهم بعدی را طی کنید.',
    ],
  },
  {
    title: 'اتصال به Search Console',
    items: [
      {
        before: 'به ',
        link: {
          href: 'https://search.google.com/search-console',
          label: 'Google Search Console',
        },
        after:
          ' بروید و همان سایتی را که می‌خواهید ایندکس کنید انتخاب کنید (مثلاً دامنهٔ فعلی شما).',
      },
      'از منوی سمت چپ Settings (تنظیمات) را باز کنید، بعد Users and permissions را بزنید.',
      'روی Add user کلیک کنید. در فیلد Email، ایمیل سرویس‌اکانتی را که بعد از آپلود JSON در همین صفحه نشان داده می‌شود paste کنید.',
      'سطح دسترسی را Owner بگذارید و Add را بزنید. بدون Owner، ایندکس و بازرسی وضعیت کار نمی‌کند.',
    ],
  },
];
